"use client";

import { nextUpV3Schema } from "../../../lib/types/schema/home/nextUpSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyNextUp } from "./keyNextUp";

export type UseRequestNextUpProps = UseRequestQueryProps;

export const useRequestNextUp = ({ ...props }: UseRequestNextUpProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: nextUpV3Schema,
      urlBackendPath: "/nextup/v3",
    },
    queryKey: keyNextUp(),
  }),
});
